// Barrel re-export for backward compatibility
// Split into separate files for easier maintenance:
//   - services.ts: servicesList
//   - features.ts: features, testimonials
//   - meta-configs.ts: MetaConfig, MetaConfigs, metaConfigs, getMetaConfig

export { servicesList } from "./services";
export { features, testimonials } from "./features";
export type { MetaConfig, MetaConfigs } from "./meta-configs";
export { metaConfigs, getMetaConfig } from "./meta-configs";
